module.exports = __webpack_public_path__ + "img/cloud-iso-cn.659d980e.png";